export default __webpack_public_path__ + "static/media/ethereum.6839bdd3.svg";